













import Vue from 'vue';

export default Vue.extend({
    name: 'LoginPage',
    components: {},
    mounted() {
        const pin = document.getElementById('inputPIN') as HTMLInputElement;
        const button = document.querySelector('#loginCon button');
        pin.focus();
        button?.addEventListener('click', () => {
            this.CheckLogin(pin.value);
        });
    },
    methods: {
        CheckLogin(pin: string) {
            const pin_input = document.getElementById('inputPIN') as HTMLInputElement;
            const ePIN = btoa(pin);
            var tp = 'MTk1OQ==';
            var ep = 'MTkwMQ==';
            console.log(ePIN);
            switch (true) {
                case ePIN === tp:
                    this.$router.push('/directory?u=tito');
                    break;
                case ePIN === ep:
                    this.$router.push('/directory');
                    break;
                default:
                    pin_input.value = '';
                    pin_input.focus();
                    break;
            }
        },
    },
});
